import * as React from 'react';
import DashboardNumbersContainer from '~/containers/Dashboard/DashboardNumbers';

import { t } from '~/i18n';
import { Panel } from '@ixicare/ui';
import DashboardAlertListContainer from '~/containers/Dashboard/DashboardAlertList';
import AlertStatusContainer from '~/containers/Alerts/AlertStatus';
import DashboardAlertActivityContainer from '~/containers/Dashboard/AlertActity';
import { usePageTitle } from '~components/DashboardWrapper/PageTitle';
import { useStores } from '~store/utils';
import { observer } from 'mobx-react';

const DashboardPage = observer(() => {
  const { sites, alerts, graphs } = useStores();
  const selectedSite = sites.selectedSite;
  usePageTitle(t('menu.dashboard.dashboard') + ' · ' + (selectedSite?.name ?? ''));

  // Refetch alerts + stats whenever the selected site changes. AlertsStore
  // swaps to the per-site bucket; AlertActivity refetches into that bucket.
  React.useEffect(() => {
    if (!selectedSite) return;
    alerts.fetchAlerts(selectedSite.uuid);
    graphs.global.loadStats(selectedSite.uuid);
    graphs.alertActivity.loadData();
  }, [selectedSite, alerts, graphs.global, graphs.alertActivity]);

  return (
    <>
      {/* No mb-30 here or on the columns below: Panel carries its own
          --panel-gap bottom margin, so an extra utility margin stacks two
          gaps between every row. */}
      <DashboardNumbersContainer />
      {/* Side by side only from xl. At md–lg the status column is barely a
          third of an already narrow page, which wraps every card title and
          stretches the chart panel to match — stacked reads better until
          there is real width to split. */}
      <div className="row">
        <div className="col-xl-8">
          <Panel>
            <Panel.Title>{t('dashboard.panels.alertActivity')}</Panel.Title>
            <DashboardAlertActivityContainer />
          </Panel>
        </div>
        <div className="col-xl-4">
          <Panel>
            <AlertStatusContainer />
          </Panel>
        </div>
      </div>
      <Panel>
        <Panel.Title>{t('dashboard.panels.recentAlerts')}</Panel.Title>
        <DashboardAlertListContainer />
      </Panel>
    </>
  );
});

export default DashboardPage;
